/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      Assistances: '$MHF_ModelNameVal_$MHF|Assistances',

};
